import React from "react";
import "@/App.css";
import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import InstantQuote from "@/components/InstantQuote";
import Services from "@/components/Services";
import Process from "@/components/Process";
import Portfolio from "@/components/Portfolio";
import About from "@/components/About";
import AIAssistant from "@/components/AIAssistant";
import FAQ from "@/components/FAQ";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import WhatsAppFab from "@/components/WhatsAppFab";

function App() {
  return (
    <div className="App grain min-h-screen bg-[#0A0A0C] text-white">
      <Navbar />
      <main>
        <Hero />
        <InstantQuote />
        <Services />
        <Process />
        <Portfolio />
        <About />
        <AIAssistant />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}

export default App;
